import { AppState } from "../reducers/root.reducer";


export const getNotificationMessage = (state: AppState): any => { 
    return  {message: state.notificationsData?.message, severity:state.notificationsData?.severity}
};
